export default __webpack_public_path__ + "static/media/Arrow.5fb07753.svg";